import { useEffect, useState } from 'react';
import { useSite } from '../context/SiteContext';
import { discountPercent, taka } from '../lib/price';
import { WhatsAppIcon } from './Icons';

// Mobile-only bottom bar: shows once the hero is scrolled past, hides while the form is on screen.
export default function StickyCTA() {
  const { course } = useSite();
  const [pastHero, setPastHero] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById('top');
    const form = document.getElementById('enroll');
    if (!hero || !form || !('IntersectionObserver' in window)) return undefined;

    const heroObs = new IntersectionObserver(([e]) => setPastHero(!e.isIntersecting), { threshold: 0 });
    const formObs = new IntersectionObserver(([e]) => setFormVisible(e.isIntersecting), { threshold: 0.15 });
    heroObs.observe(hero);
    formObs.observe(form);
    return () => {
      heroObs.disconnect();
      formObs.disconnect();
    };
    // The #enroll section is swapped out when enrollment opens/closes, so re-observe then.
  }, [course.enrollmentOpen]);

  const show = course.enrollmentOpen && pastHero && !formVisible;
  const { whatsapp } = course.contact;

  return (
    <>
      {course.enrollmentOpen && (
        <div
          aria-hidden={!show}
          className={`fixed inset-x-0 bottom-0 z-40 border-t border-slate-200 bg-white/95 px-4 py-3 shadow-[0_-8px_24px_rgba(15,23,42,0.08)] backdrop-blur transition-transform duration-300 md:hidden ${
            show ? 'translate-y-0' : 'translate-y-full'
          }`}
        >
          <div className="flex items-center gap-3">
            {course.price != null && (
              <div className="leading-tight">
                <div className="text-xl font-bold text-slate-900">{taka(course.price)}</div>
                {discountPercent(course) && <div className="text-sm text-slate-400 line-through">{taka(course.regularPrice)}</div>}
              </div>
            )}
            <a href="#enroll" className="btn-cta flex-1 py-3 text-base">
              সিট বুক করুন
            </a>
          </div>
        </div>
      )}

      {whatsapp && (
        <a
          href={`https://wa.me/${whatsapp}`}
          target="_blank"
          rel="noreferrer"
          aria-label="WhatsApp-এ যোগাযোগ করুন"
          className={`fixed right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all hover:scale-105 md:bottom-6 ${
            show ? 'bottom-24' : 'bottom-6'
          }`}
        >
          <WhatsAppIcon className="h-7 w-7" />
        </a>
      )}
    </>
  );
}
